import { Stack } from '@mui/material'
import type { WidgetConfig } from 'components/farm-dashboard/types'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { DockDraggableCard } from '../dock-draggable-card/DockDraggableCard'

interface LicensedWidgetsSectionProps {
	widgets: WidgetConfig[]
	title: string
}

export const LicensedWidgetsSection = ({
	widgets,
	title,
}: LicensedWidgetsSectionProps) => {
	if (widgets.length === 0) return null

	return (
		<Stack direction='column' gap='16px'>
			<TypographySecondary>{title}</TypographySecondary>
			<Stack
				direction='row'
				width='100%'
				gap='24px'
				flexWrap='wrap'
				alignItems='center'
			>
				{widgets.map(widget => (
					<DockDraggableCard key={widget.id ?? widget.type} widget={widget} />
				))}
			</Stack>
		</Stack>
	)
}
